<template>
    <div class="row choice-wrap">
        <div class="" v-bind:class="colClass">
            <div class="title d-flex flex-row align-items-start  mb-4" v-if="$slots.title">
                <slot name="title"></slot>
            </div>
            <div class="row">
                <div class=" col-12 col-lg-7" v-bind:class="choiceColClass">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ChoiceWrap",
        props: {
            colClass:{
                type: [String, Array, Object],
                default: 'col-12 border-bottom pt-5 pb-4'
            },
            choiceColClass: [String, Array, Object],
        }
    }
</script>
